import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "gitlab",
  "name": "GitLab",
  "category": "integrations",
  "description": "Interact with GitLab repositories and issues",
  "icon": "siGitlab",
  "iconType": "simple-icon",
  "color": "orange",
  "version": "1.3.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "GitLab",
    "color": "#fc6d26"
  },
  "credentials": [
    {
      "name": "gitlabApi",
      "required": true,
      "displayName": "GitLab API"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "gitlab",
    "git",
    "repository",
    "code",
    "ci-cd"
  ],
  "comingSoon": true
};

export default definition;
